export const OTHERGOODS_APPROVAL_REQUEST = "OTHERGOODS_APPROVAL_REQUEST";
export const OTHERGOODS_APPROVAL_SUCCESS = "OTHERGOODS_APPROVAL_SUCCESS";
export const OTHERGOODS_APPROVAL_FAILED = "OTHERGOODS_APPROVAL_FAILED";
